export default __webpack_public_path__ + "static/media/coffeemap_905x.bda7e1ca.jpg";